import { inject, Pipe, PipeTransform } from '@angular/core';
import { LOCALIZED_SHARED_ROUTES, SHARED_ROUTE_IDS } from '../shared-route-const';
import { LocalizedRouteService } from '../services/localized-route.service';

@Pipe({
  name: 'sharedPath',
})
export class SharedPathPipe implements PipeTransform {
  private readonly localizedRouteService = inject(LocalizedRouteService);

  public transform(routeId: keyof typeof SHARED_ROUTE_IDS): string {
    return `/${this.localizedRouteService.getLocalizedRoute(LOCALIZED_SHARED_ROUTES[SHARED_ROUTE_IDS[routeId]])}`;
  }
}
